<template>
  <v-select
    :searchable="false"
    :options="options"
    placeholder="Sortieren nach"
    v-model="selected"
    :clearable="false"
    :reduce="option => option.value"
    @input="submit"
  ></v-select>
</template>

<script>
import vSelect from "vue-select";
export default {
  props: {
    options: {
      type: Array
    }
  },
  components: {
    vSelect
  },

  data() {
    return {
      selected: null
    };
  },

  mounted() {
    this.selected = this.$route.query.sortBy || null;
  },

  methods: {
    submit() {
      this.$emit('change', this.selected)
    }
  }
};
</script>
